import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { ValueDescription } from '../../../value-description/value-description';
import { CardDashboardTradesLoading } from '../card-loading/card-dashboard-trades-loading';
import { useRootStore } from '../../../../../../providers/root-store-provider';
import { getColor } from '../../../../tables/utils/get-color';
import { ValueAmount } from '../../../../value/amount/value-amount';
import { CardTitle } from '../../../title/card-title';

export const CardDashboardTradesCurrencyImpact: React.FC = observer(() => {
    const { t } = useTranslation();
    const { statisticStore, portfolioStore } = useRootStore();

    const portfolioCurrency = portfolioStore.selectedPortfolio.portfolioHistoryCurrencyCode;

    return (
        <CardDashboardTradesLoading>
            <div className="relative flex h-full flex-col items-start justify-between overflow-hidden rounded-large bg-surface p-[1.6rem] shadow-strong lg:p-[2.2rem] max-md:bg-[url('/images/card-stats/currency-impact-bg.svg')] max-md:bg-[length:8rem] max-md:bg-[position:100%_100%] max-md:bg-no-repeat">
                <CardTitle
                    title={t('layout.statisticsCard.rateImpact.title')}
                    tooltip={t('layout.statisticsCard.rateImpact.tooltip')}
                />
                <ValueDescription
                    padding={'none'}
                    value={
                        <ValueAmount
                            amount={statisticStore.overviewStore.overview?.rateImpact ?? 0}
                            currency={portfolioCurrency}
                            mode="pure"
                            hidable
                        />
                    }
                    valueColor={getColor(statisticStore.overviewStore.overview?.rateImpact ?? 0, 0, false)}
                />
            </div>
        </CardDashboardTradesLoading>
    );
});
